import './attendance-config.service';
import './credit-gaps-config.service';
import './default-sdc-config.service';
import './grad-planning-config.service';
import './pending-course-gap-plan-table-config.service';
import './regents-planning-config.service';
import './regents-prep-config.service';